<template>
  <div>
    <div v-if="modifyProfile == 'Selected'">
      <profile @modifyProfile="displayAllProfile"></profile>
    </div>

    <div v-if="modifyProfile == 'All'">
      <div class="grouptwo">
        <div>
          <div class="fileUpload btn btn-primary">
            <!-- <img :src="profileobject.imagefile" id="output"  width="50" height="50" top="0" right="0" radius="10"  class="profileimage"/>-->
            <input
              type="file"
              class="upload"
              accept="image/*"
              name="image"
              id="file"
              @change="loadFile()"
            />
          </div>
        </div>
        <p>
          Welcome to
          <b>Work Notion</b>
          <br />please provide basic information
        </p>
        <button class="button buttonleft">Edit Profile</button>
      </div>
      <div class="groupone"></div>
      <div class="columnbackground">
        <p>VIDEO PROFILE</p>
        <div class="groupbutton">
          <button class="button">Upload</button>&nbsp;&nbsp;&nbsp;
          <button class="button">Create</button>
        </div>
      </div>
      <div class="columnbackground">
        <p>VIDEO RESUME</p>
        <div class="groupbutton">
          <button class="button">Upload</button>&nbsp;&nbsp;&nbsp;
          <button class="button">Create</button>
        </div>
      </div>

      <h2>Profile Details</h2>
      <div class="groupdeatilstop">
        <p class="width40">Contact Details</p>
        <div class="buttonleft">
          <button id="customerbutton" @click="editcontactdetails(profileId)">Edit</button>
        </div>
      </div>

      <div>
        <div class="groupdeatils">
          <div class="form-group">
            <div class="col-15">
              <label>Email Address</label>
            </div>
            <div class="col-30">
              <label class="fontweight">{{email}}</label>
            </div>

            <div class="col-15">
              <label>Primary Mobile Number</label>
            </div>
            <div class="col-30">
              <label class="fontweight">{{primaryPhoneNumber}}</label>
            </div>
          </div>

          <div class="form-group">
            <div class="col-15">
              <label>Alternative Mobile Number</label>
            </div>
            <div class="col-30">
              <label class="fontweight">{{alternatePhoneNumber}}</label>
            </div>
            <div class="col-15">
              <label>Website / Potfolio URL</label>
            </div>
            <div class="col-30">
              <label class="fontweight">{{websiteUrl}}</label>
            </div>
          </div>
        </div>
        <br />

        <div class="groupdeatilstop">
          <p class="width40">Work Experience</p>
          <div class="buttonleft">
            <button id="customerbutton">Add</button>
            <button id="customerbutton" @click="editcontactdetails(profileId)">Edit</button>
          </div>
        </div>

        <div class="groupdeatils" v-for="(exep,index) in experience" v-bind:key="index">
          <div>
            <div class="form-group">
              <div class="col-30">
                <label class="fontweight">{{experience[index].company}}</label>
              </div>
            </div>
            <div class="form-group">
              <div class="col-30">
                <label>{{experience[index].jobRole}}</label>
              </div>

              <div>
                <label>{{experience[index].jobType}}</label>
              </div>
            </div>
            <div class="form-group">
              <div class="col-30">
                <label>{{experience[index].startDate| moment("MM/DD/YYYY")}}</label>
              </div>

              <div>
                <label>{{experience[index].endDate| moment("MM/DD/YYYY")}}</label>
              </div>
            </div>
          </div>
        </div>
        <br />
        <div class="groupdeatilstop">
          <p class="width40">Highest Education</p>
          <div class="buttonleft">
            <button id="customerbutton" @click="editcontactdetails(profileId)">Edit</button>
          </div>
        </div>
        <div class="groupdeatils" v-for="(education,index) in certificates" v-bind:key="index">
          <div>
            <div class="form-group">
              <div class="col-30">
                <label>{{certificates[index].institutionName}}</label>
              </div>
            </div>
            <div class="form-group">
              <div class="col-30">
                <label>{{certificates[index].typeOfDegree}}</label>
              </div>

              <div>
                <label>{{certificates[index].fieldOfStudy}}</label>
              </div>
            </div>
            <div class="form-group">
              <div class="col-30">
                <label>{{certificates[index].location}}</label>
              </div>

              <div>
                <label>{{certificates[index].fromDate | moment("MM/DD/YYYY")}}</label>
              </div>
              <div>
                <label>{{certificates[index].toDate | moment("MM/DD/YYYY")}}</label>
              </div>
            </div>
          </div>
        </div>
        <br />
        <div class="groupdeatilstop">
          <p class="width40">Current Location</p>
          <div class="buttonleft">
            <button id="customerbutton" @click="editcontactdetails(profileId)">Edit</button>
          </div>
        </div>
        <div class="groupdeatils">
          <div class="form-group">
            <div class="col-30">
              <label>{{country}}</label>
            </div>
          </div>
          <div class="form-group">
            <div class="col-30">
              <label>{{state}}</label>
            </div>

            <div>
              <label>{{zipCode}}</label>
            </div>
          </div>
          <div class="form-group">
            <div class="col-30">
              <label>{{workAuthorization}}</label>
            </div>
          </div>
        </div>
        <br />

        <div class="groupdeatilstop">
          <p class="width40">Skills</p>
          <div class="buttonleft">
            <button id="customerbutton" @click="editcontactdetails(profileId)">Edit</button>
          </div>
        </div>
        <div class="groupdeatils" v-for="(skill,index) in skills" v-bind:key="index">
          <div>
            <div class="form-group">
              <div class="col-30">
                <label>{{skills[index].knowledgeIn}}</label>
              </div>
            </div>
            <div class="form-group">
              <div class="col-30">
                <label>{{skills[index].technologyTools}}</label>
              </div>
            </div>
          </div>
        </div>
        <br />

        <div class="groupdeatilstop">
          <p class="width40">Videos</p>
          <div class="buttonleft">
            <button id="customerbutton" @click="editcontactdetails(profileId)">Edit</button>
          </div>
        </div>
      </div>
      <div class="groupdeatils"></div>
    </div>
  </div>
</template>
<script>
import httpuserprofile from "@/js/http-userprofile.js";
import profile from "@/components/ProfileCreation.vue";
import { bus } from "../main";
export default {
  props: ["profileobject"],
  components: {
    profile
  },

  data() {
    return {
      userdatalist: [],
      firstname: "",
      lastname: "",
      gender: "",
      companyname: "",
      designation: "",
      aboutYou: "",
      primaryPhoneNumber: "",
      alternatePhoneNumber: "",
      email: "",
      websiteUrl: "",
      description: "",
      country: "",
      workAuthorization: "",
      state: "",
      city: "",
      zipCode: "",
      profile: "",
      profilePictureName: "",
      profileVideoName: "",
      fresherOrExperience: "",
      workLocationPreference: "",
      profileId: this.$session.get("profileId"),
      modifyProfile: "All",
      experience: [
        {
          company: "",
          jobRole: "",
          jobType: "",
          startDate: "",
          endDate: "",
          currentWorkingFlag: ""
        }
      ],

      certificates: [
        {
          institutionName: "",
          typeOfDegree: "",
          fieldOfStudy: "",
          location: "",
          fromDate: "",
          toDate: "",
          currentStudyFlag: ""
        }
      ],
      skills: [
        {
          knowledgeIn: "",
          technologyTools: "",
          profileId: this.$session.get("profileId")
        }
      ]
    };
  },
  methods: {
    fetchdata() {
      this.getprofiledata();
    },
    displayAllProfile: function(value) {
      this.modifyProfile = value;
    },
    getprofiledata() {
      httpuserprofile
        .get("/userprofile/userbyid/" + parseInt(this.profileId))
        .then(response => {
          this.userdatalist = response.data;
          this.email = this.userdatalist.email;
          this.primaryPhoneNumber = this.userdatalist.primaryPhoneNumber;
          this.alternatePhoneNumber = this.userdatalist.alternatePhoneNumber;
          this.websiteUrl = this.userdatalist.websiteUrl;
          this.profileId = this.userdatalist.profileId;
          this.country = this.userdatalist.country;
          this.state = this.userdatalist.state;
          this.city = this.userdatalist.city;
          this.ZipCode = this.userdatalist.zipCode;

          if (this.userdatalist.profileId != null) {
            this.experience = this.userdatalist.workExperience;
            this.experience.push({
              company: this.experience.company,
              jobRole: this.experience.jobRole,
              jobType: this.experience.jobType,
              startDate: this.experience.startDate,
              endDate: this.experience.endDate,
              currentWorkingFlag: this.experience.currentWorkingFlag
            });
          }

          this.certificates = this.userdatalist.userEducation;
          this.certificates.push({
            institutionName: this.certificates.institutionName,
            typeOfDegree: this.certificates.typeOfDegree,
            fieldOfStudy: this.certificates.fieldOfStudy,
            location: this.certificates.location,
            fromDate: this.certificates.startDate,
            toDate: this.certificates.toDate,
            currentStudyFlag: this.certificates.currentStudyFlag
          });

          this.skills = this.userdatalist.userSkill;
          this.skills.push({
            knowledgeIn: this.skills.knowledgeIn,
            technologyTools: this.skills.technologyTools
          });
        });
    },
    editcontactdetails(value) {
      this.$store.state.profileId = value;
      bus.$emit("profileId", value);
      this.modifyProfile = "Selected";
      this.$session.start();
      this.$session.set("profileId", this.profileId);
    },
    createprofile() {
      this.$emit("profileChanged", this.profileobject);
      this.profileobject.profilehome = true;
      this.profileobject.profile = true;
      this.profileobject.profilecreation = "profile";
    },
    loadFile: function() {
      var image = document.getElementById("file").value;

      this.profileobject.imagefile = URL.createObjectURL(event.target.files[0]);
    }
  },

  mounted: function() {
    this.fetchdata();
  }
};
</script>
<style scoped>
</style>